import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap-modal'
import Tips from './tips'
import Custom from './custom'
import Signing from './signing'

function Signature(props) {
  const [step, setStep] = useState('tips')
  const [prevStep, setPrevStep] = useState()
  const [tip, setTip] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!props.error) return

    setLoading(false)
  }, [props.error])

  const onTipSelected = (value) => {
    setTip(value)
    setPrevStep(step)
    setStep('signing')
  }

  const onSigningDone = (data) => {
    props.onComplete({tipAmount: tip, data: data})
    setLoading(true)
  }

  return <Modal dialogClassName='tips-modal' className='tips-dialog' backdrop='static' container={document.body} show={true}>
    <Modal.Body>
      { loading && <div className='animated-spinner'></div> }
      { step == 'tips' && 
        <Tips
          amount={props.amount}
          values={props.values || '10, 15, 20'}
          onSelected={onTipSelected}
          onCustom={() => setStep('custom')}
          onCancel={props.onClose}
        />
      }
      { step == 'custom' && 
        <Custom
          amount={props.amount}
          tip={tip}
          onSelected={onTipSelected}
          onCancel={() => setStep('tips')}
        />
      }
      { step == 'signing' && 
        <Signing
          amount={props.amount}
          tip={tip}
          loading={loading}
          onComplete={onSigningDone}
          onBack={() => setStep(prevStep)}
        />
      }
    </Modal.Body>
  </Modal>
}

Signature.propTypes = {
  amount: PropTypes.string.isRequired,
  error: PropTypes.object,
  values: PropTypes.string,
  receipt: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onSendReceipt: PropTypes.func.isRequired,
}

export default Signature
